// constants
var LAST_CONTEXT_KEY = "X-Tiz-Last-Distributor-Context";
var CONTEXT_KEY = "X-Tiz-Distributor-Context";
var ONBOARDING_WARNINGS = "X-Tiz-Onboarding-Warnings";

var service = function ($state) {
  const setCurrentDistributorContext = function (id) {
    localStorage.setItem(LAST_CONTEXT_KEY, id);
    sessionStorage.setItem(CONTEXT_KEY, id);
    $rootScope.currentDistributor = id;
  };

  const setOnboardingWarnings = function (warnings, current_user_id) {
    var data = { warnings: warnings, current_user: current_user_id };
    localStorage.setItem(ONBOARDING_WARNINGS, JSON.stringify(data));
  };

  const getOnboardingWarnings = function () {
    return JSON.parse(localStorage.getItem(ONBOARDING_WARNINGS));
  };

  const clearOnboardingWarnings = function () {
    localStorage.removeItem(ONBOARDING_WARNINGS);
  };

  const getActiveDistributors = function () {
    return $rootScope.user?.distributors || [];
  };

  const getPaymentEnabledDistributors = function () {
    return getActiveDistributors().filter(d => d.uses_term_payments);
  };

  const distributorCount = function () {
    return getActiveDistributors().length > 1;
  };

  const getCurrentDistributorId = function () {
    return (
      Number(sessionStorage.getItem(CONTEXT_KEY)) ||
      $rootScope.user?.distributors[0]?.distributor_id
    );
  };

  const getCurrentDistributor = function () {
    return _.find(getActiveDistributors(), { distributor_id: getCurrentDistributorId() });
  };

  const reloadState = function () {
    var currentDistributor = getCurrentDistributor();
    var pageName = $state.current.name;

    if (pageName === "layout.sales_rep_details") {
      window.location.assign("/distributor/sales_reps");
    } else if (
      pageName == "layout.referrals" &&
      currentDistributor.uses_referrals == "onboard_retailers"
    ) {
      window.location.assign("/distributor/retailer_onboarding");
    } else if (
      pageName == "layout.retailer_onboarding" &&
      currentDistributor.uses_referrals == "refer_and_earn"
    ) {
      window.location.assign("/distributor");
    } else {
      location.reload();
    }
  };

  return {
    initialize: function () {
      let distributors = getActiveDistributors();
      // set web session storage
      var currentDistributorId = Number(sessionStorage.getItem(CONTEXT_KEY));
      if (!currentDistributorId) {
        currentDistributorId = Number(localStorage.getItem(CONTEXT_KEY));
        if (currentDistributorId) {
          sessionStorage.setItem(CONTEXT_KEY, currentDistributorId);
        }
      }
      $rootScope.currentDistributor = currentDistributorId || null;
    },
    getAllDistributors: getActiveDistributors,
    getCurrentDistributor: getCurrentDistributor,
    hasMultipleDistributors: distributorCount,
    setCurrentDistributorContext: function (id) {
      setCurrentDistributorContext(id);
    },
    setDistributorReloadState: function (id) {
      setCurrentDistributorContext(id);
      reloadState();
    },
    setOnboardingWarnings: setOnboardingWarnings,
    getOnboardingWarnings: getOnboardingWarnings,
    clearOnboardingWarnings: clearOnboardingWarnings,
    getPaymentEnabledDistributors: getPaymentEnabledDistributors,
  };
};

service.$inject = ["$state"];
tiz.service("DistributorContext", service);
